<div [style.background-color]="props.background"
     [style.border-radius]='props.borderradius'
     [style.font-size]='props.fontSize'
     [style.height]='props.size'
     [style.line-height]='props.lineheight'
     [style.width]="props.size"
     class="avatar">
  <span [style.color]='fontColor' class="avatar-letter">{{ letter }}</span>
</div>
